<template>
    <div v-if="invoice">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="請求キャンセル"
            ok-title="キャンセルを確定"
            ok-variant="yokumiru-orange"
            cancel-title="戻る"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="cancel"
            @hidden="cancel">
            <form @submit.stop.prevent="cancelPayment">
                <div class="d-flex justify-content-between">
                    <div>確定日時：</div>
                    <div>{{ helper.dateTimeForHuman(invoice.authorized_at, 'Asia/Tokyo') }}</div>
                </div>

                <hr class="mt-1 mb-1">

                <div class="d-flex justify-content-between">
                    <div>請求内容：</div>
                    <div>{{ invoice.content }}</div>
                </div>

                <hr class="mt-1 mb-3">

                <div class="d-flex justify-content-between">
                    <div class="font-weight-bold">料金：</div>
                    <div class="font-weight-bold">
                        <span>{{ invoice.total.toLocaleString() }}</span>
                        <span class="small">円</span>
                    </div>
                </div>

                <div
                    v-if="errors.message"
                    class="invalid-feedback d-flex justify-content-center mt-3">
                    {{ errors.message[0] }}
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import constants from "../../../constants"
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: "CancelInvoiceModal",

        data: function() {
            return {
                helper: YokumiruHelper,
                inProgress :false,
                modalShow: false,
                invoice: null,
                errors: {},
            }
        },

        created: async function () {
            bus.$on('open-modal-cancel-invoice', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-cancel-invoice')
        },

        methods: {
            open: function (invoice) {
                this.invoice = invoice
                this.modalShow = true
            },

            handleOk(e) {
                e.preventDefault()
                this.cancelPayment()
            },

            cancelPayment: async function () {
                if (this.inProgress) return
                this.inProgress = true

                axios.post(`${constants.admin.invoices.endpoint.base}/${this.invoice.id}/cancel`)
                    .then(({data}) => {
                        bus.$emit('invoice-canceled', data.data)
                        bus.$emit('alert-success', '請求をキャンセルしました。')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger', '請求をキャンセルできませんでした。')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            cancel: function () {
                this.initialize()
                this.close()
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.invoice = null
                this.errors = {}
            },
        },
    }
</script>

<style scoped lang="scss">
    @media only screen and (min-width: 992px) {
        .mb-errors {
            margin-bottom: 22px;
        }
    }
</style>
